import { render, staticRenderFns } from "./reisetermin-card-flugdata.vue?vue&type=template&id=3b227867"
import script from "./reisetermin-card-flugdata.vue?vue&type=script&lang=js"
export * from "./reisetermin-card-flugdata.vue?vue&type=script&lang=js"
import style0 from "./reisetermin-card-flugdata.vue?vue&type=style&index=0&id=3b227867&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports